import { InboxOutlined } from '@ant-design/icons';
import type { UploadFile, UploadProps } from 'antd';
import { Button, Card, Progress, Typography, Upload } from 'antd';

const { Dragger } = Upload;
const { Text } = Typography;

interface FileSelectorProps {
	fileList: UploadFile[];
	uploading: boolean;
	uploadProgress: Record<string, number>;
	uploadProps: UploadProps;
	onUpload: () => void;
}

export function FileSelector({
	fileList,
	uploading,
	uploadProgress,
	uploadProps,
	onUpload,
}: FileSelectorProps) {
	return (
		<Card title="选择文件" style={{ marginBottom: 24 }}>
			<Dragger {...uploadProps}>
				<p className="ant-upload-drag-icon">
					<InboxOutlined />
				</p>
				<p className="ant-upload-text">点击或拖拽文件到此区域上传</p>
				<p className="ant-upload-hint">支持单个或批量上传</p>
			</Dragger>

			{fileList.length > 0 && (
				<div style={{ marginTop: 16 }}>
					{Object.entries(uploadProgress).map(([uid, percent]) => (
						<div key={uid} style={{ marginBottom: 8 }}>
							<Text>{fileList.find((f) => f.uid === uid)?.name}</Text>
							<Progress percent={percent} size="small" />
						</div>
					))}
				</div>
			)}

			<Button
				type="primary"
				onClick={onUpload}
				loading={uploading}
				disabled={fileList.length === 0}
				style={{ marginTop: 16 }}
			>
				{uploading ? '上传中...' : '开始上传'}
			</Button>
		</Card>
	);
}
